import { useMutation } from '@tanstack/react-query';

import type { BookingProviderMutationResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useDeleteBookingProviderMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; id: number }) =>
      HttpClient.request<BookingProviderMutationResponse>({
        method: 'DELETE',
        url: `${params.url}/${params.id}`,
      }),
  });
